// Базовият адрес на API-то, изнесен ОТДЕЛНО от axios инстанцията, за да може и
// код извън `src/api` (възстановяването на сесията в `sessionRecovery.ts`) да
// удря същия адрес, без да импортира `api/client.ts` — иначе се получава цикъл
// client.ts → sessionRecovery.ts → client.ts.
//
// ВНИМАНИЕ: `src/api/auth.ts` пази СВОЙ израз със fallback към
// "http://127.0.0.1:8000" (за login/login-with-code при локална разработка).
// Тук fallback-ът е "" (same-origin) — това е адресът, по който върви реалният
// трафик на приложението, и точно него трябва да ползва пробата на сесията.

import { getEdgeBaseUrl, isEdgeLocalMode } from "./edge/edgeState";

// runtime конфиг от /config.js (ако го има)
declare global {
  interface Window {
    __ENV?: {
      VITE_API_BASE_URL?: string;
      VITE_SENTRY_DSN?: string;
      VITE_SENTRY_ENVIRONMENT?: string;
      VITE_APP_VERSION?: string;
      // Границата на работния ден в часове след полунощ (виж `businessDay.ts`).
      VITE_BUSINESS_DAY_START?: string;
    };
  }
}

const runtimeBase =
  typeof window !== "undefined" ? window.__ENV?.VITE_API_BASE_URL : undefined;

// 1) runtime (/config.js), 2) build-time (Vite), 3) fallback ""
export const API_BASE_URL: string =
  runtimeBase ?? import.meta.env.VITE_API_BASE_URL ?? "";

/**
 * Базовият адрес ЗА ТЕКУЩИЯ РЕЖИМ — смята се ПРИ ВСЯКА заявка (axios
 * интерсепторът в api/client.ts, login-ите в api/auth.ts): в локален режим
 * (docs/edge.md) заявките отиват към главната каса
 * (`http://{ip}:{port}/edge`, същите пътища като на BE), иначе към облака.
 * Сондите към облака и възстановяването на сесията НАРОЧНО остават на
 * `API_BASE_URL` — те питат точно облака.
 */
export function getApiBaseForMode(): string {
  if (isEdgeLocalMode()) {
    const edgeBase = getEdgeBaseUrl();
    if (edgeBase) return edgeBase;
  }
  return API_BASE_URL;
}
